import {navigate} from '../actions/navigation'
import {placeOrder, updateOrder} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {State} from '../types/state'

export const isRequestPendingOld = (state: State, requestName: string) =>
  Boolean(state.pendingRequestsOld.requestNames.find(name => name === requestName))

export const isCheckoutActionPendingOld = (state: State): boolean => {
  const updateOrderInProgress = isRequestPendingOld(state, 'UPDATE_ORDER_OLD_REQUEST')

  const placeOrderInProgress = isRequestPendingOld(state, 'PLACE_ORDER_OLD_REQUEST')

  const reserveTicketsInProgress = isRequestPendingOld(state, 'RESERVE_TICKETS_OLD_REQUEST')

  const navigateInProgress = isRequestPendingOld(state, 'NAVIGATE_OLD')

  return updateOrderInProgress || placeOrderInProgress || reserveTicketsInProgress || navigateInProgress
}

export const isRequestPending = (state: State, actionType: string) => !!state.pendingRequests.loading[actionType]

export const isCheckoutActionPending = (state: State): boolean => {
  const updateOrderInProgress = isRequestPending(state, updateOrder.typePrefix)

  const placeOrderInProgress = isRequestPending(state, placeOrder.typePrefix)

  const reserveTicketsInProgress = isRequestPending(state, makeReservation.typePrefix)

  const navigateInProgress = isRequestPending(state, navigate.typePrefix)

  return updateOrderInProgress || placeOrderInProgress || reserveTicketsInProgress || navigateInProgress
}
